import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import { EServices } from "@/types";
import { IVForm } from "@/types";
import { emailRule, requiredRule, usernameEmailRule } from "@/utils/rules";
import { Component, Ref, Mixins, Inject } from "vue-property-decorator";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import AuthClient from "../../services/AuthClient";
import JsonResponse from "@/utils/http/JsonResponse";
import { namespace } from "vuex-class";
import { IAccount } from "../../types";
import { startAuthentication } from "@/utils/webauth";
import { IBiometricClient } from "@/modules/dashboard/types";

const AccountModule = namespace("AccountModule");

@Component
export default class Login extends Mixins(JackocoinsNetworkManagerMixin) {
  @Inject(EServices.auth)
  authClient!: AuthClient;

  userId = "";
  password = "";
  captchaToken = "";

  @Ref()
  loginForm!: IVForm;

  @AccountModule.State
  account!: IAccount;

  usernameEmailRule = usernameEmailRule;
  requiredRule = requiredRule;
  turnstileContainerId = `turnstile-${Math.random()
    .toString(36)
    .substring(2, 10)}-login`;

  @Inject(EServices.biometric)
  biometricClient!: IBiometricClient;

  createTurnstileWidget() {
    turnstile.render(`#${this.turnstileContainerId}`, {
      sitekey: "0x4AAAAAACxL73T6KYGIrcnM",
      theme: "light",
      callback: (token: string) => {
        this.captchaToken = token;
      },
    });
  }

  @throwsNetworkError()
  async login() {
    if (!this.loginForm.validate()) return;
    try {
      const response = await this.authClient.login(
        this.userId,
        this.password,
        this.captchaToken
      );
    } catch (e) {
      if (e instanceof JsonResponse && e.status == 404)
        await this.authClient.oldLogin(this.userId, this.password);
      else throw e;
    }

    this.$router.replace("/dashboard");
  }

  @throwsNetworkError()
  async beginAuthentication() {
    const resp = await this.biometricClient.getAuthenticationOptions();
    const opts = resp.data;
    const asseResp = await startAuthentication(opts);
    const verificationResp = await this.biometricClient.authenticate(asseResp);
    if (verificationResp && verificationResp.data) {
      this.$router.replace("/dashboard");
    } else {
      toast({
        icon: "mdi-exlamation-think",
        iconColor: "red",
        message: "Error login",
      });
    }
  }

  mounted() {
    this.createTurnstileWidget();
  }
}
